<app-modal-card>
  <p class="text-[68px] leading-none" aria-hidden="true">⚠️</p>

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  @if (subtitle()) {
    <p class="text-[14px] fg-gris-1 text-center mt-[12px] whitespace-pre-line">{{ subtitle() }}</p>
  }

  <div class="flex gap-[10px] w-[400px] mt-auto">
    <button
      type="button"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex-1 flex items-center justify-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
      (click)="cancelClick.emit()"
    >
      {{ cancelLabel() }}
    </button>
    <button
      type="button"
      class="h-[58px] flex-1 px-[20px] flex items-center justify-center bg-rose-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer hover:brightness-95 transition-all"
      (click)="confirmClick.emit()"
    >
      {{ confirmLabel() }}
    </button>
  </div>
</app-modal-card>
